export enum DIRECTORY_TYPE {
  CONTACT_ATTACHMENT = 'CONTACT_ATTACHMENT',
  CONTACT_COVER_IMAGE = 'CONTACT_COVER_IMAGE',
  COMPANY_LOGO = 'COMPANY_LOGO',
  PROFILE_IMAGES = 'PROFILE_IMAGES',
  STORE_COVER = 'STORE_COVER',
  PRODUCT_COVER = 'PRODUCT_COVER',
  STORE_ATTACHMENT = 'STORE_ATTACHMENT',
  KNOWLEDGE_BASE_CONTENT_COVER = 'KNOWLEDGE_BASE_CONTENT_COVER',
  KNOWLEDGE_BASE_CONTENT_BODY_IMAGES = 'KNOWLEDGE_BASE_CONTENT_BODY_IMAGES',
  KNOWLEDGE_BASE_CONTENT_ATTACHMENTS = 'KNOWLEDGE_BASE_CONTENT_ATTACHMENTS',
  ACTIVITY_ATTACHMENTS = 'ACTIVITY_ATTACHMENTS',
  OPPORTUNITY_ATTACHMENTS = 'OPPORTUNITY_ATTACHMENTS'
}

export enum EXTENSION_TYPE {
  CSV = 'CSV',
  DOC = 'DOC',
  DOCX = 'DOCX',
  JPEG = 'JPEG',
  JPG = 'JPG',
  MP4 = 'MP4',
  MP3 = 'MP3',
  PDF = 'PDF',
  PNG = 'PNG',
  PPT = 'PPT',
  PPTX = 'PPTX',
  XLSX = 'XLSX',
  XLS = 'XLS',
  XLSM = 'XLSM',
  EML = 'EML',
  ZIP = 'ZIP'
}

export type PostFileParams = {
  directory_type: keyof typeof DIRECTORY_TYPE
  extension_type: keyof typeof EXTENSION_TYPE
}

export type PresignedUrlResponse = {
  url: string
  file_name: string
}

export type PutUploadFile = {
  files: string[] // uri local file
}

export type UploadFilePayload = PostFileParams & {
  files: Blob[]
}

export type UploadFileResponse = {
  url: string
  name: string
  status: number
}
